(function(){
  var tiers=[].slice.call(document.querySelectorAll('.tier'));
  var addons=[].slice.call(document.querySelectorAll('.addon'));
  var totalEl=document.getElementById('total');
  var qtyInput=document.getElementById('qty');
  var qtyCov=document.getElementById('qtycov');
  var subSel=document.getElementById('substrate');
  var actRow=document.getElementById('activatorRow');
  var actPrice=document.getElementById('actPrice');
  var COVERAGE=200, RV_WIDTH=8;

  // Color Activator: variant id by "Size|Color". No pint/quart variants exist.
  var ACT={price:{'1 Gallon':23.72,'5 Gallon':118.63},id:{
   '1 Gallon':{'White':43024652402922,'Rockslide Grey':43024652435690,'Monday Grey':43024652468458,
    'Black Pearl':43024652501226,'Cove Blue':43024652533994,'Sapphire Bay':43024652566762,
    'Sandy Beige':43024652599530,'Honey Maple':43024652632298,'Arizona Sun':43024652665066,
    'Brown Slate':43024652697834,'Sequoia Brown':43024652730602,'Hunter Green':43024652763370,
    'SEMCO Orange':43024652796138,'Barn Red':51984531980654},
   '5 Gallon':{'White':43024652828906,'Rockslide Grey':43024652861674,'Monday Grey':43024652894442,
    'Black Pearl':43024652927210,'Cove Blue':43024652992746,'Sapphire Bay':43024653025514,
    'Sandy Beige':43024653058282,'Honey Maple':43024653091050,'Arizona Sun':43024653123818,
    'Brown Slate':43024653156586,'Sequoia Brown':43024653189354,'Hunter Green':43024653222122,
    'SEMCO Orange':43024653254890,'Barn Red':51984532013422}}};

  function money(n){return '$'+n.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g,',');}
  function qty(){ return Math.max(1,parseInt(qtyInput.value,10)||1); }
  function currentTier(){ return document.querySelector('.tier.on'); }
  function currentColor(){ var el=document.querySelector('.sw.on'); return el?el.dataset.name:null; }

  // ---- Color Activator must always match the membrane size, color AND count ----
  function syncActivator(){
    if(!actRow) return;
    var t=currentTier(), size=t?t.dataset.size:'', c=currentColor();
    var cb=actRow.querySelector('input[type="checkbox"]');
    var qf=actRow.querySelector('.addon__q');
    var wrap=actRow.querySelector('.addon__qty');
    var available=!!(ACT.price[size] && c && ACT.id[size] && ACT.id[size][c]);

    if(!available){                       // no activator for pint/quart, or untested color
      cb.checked=false; cb.dataset.price=0; delete cb.dataset.variant;
      actRow.classList.remove('on');
      if(wrap) wrap.setAttribute('hidden','');
      actRow.setAttribute('hidden','');
      return;
    }
    actRow.removeAttribute('hidden');
    cb.dataset.price=ACT.price[size];
    cb.dataset.variant=ACT.id[size][c];
    if(qf) qf.value=qty();                // one activator per container of membrane
    if(wrap){ if(cb.checked){wrap.removeAttribute('hidden');} else {wrap.setAttribute('hidden','');} }
    if(actPrice) actPrice.textContent=cb.checked?money(ACT.price[size]*qty()):money(ACT.price[size]);
  }

  function recalc(){
    var t=currentTier();
    var sum=t?parseFloat(t.dataset.price)*qty():0;
    addons.forEach(function(a){
      if(a.hasAttribute('hidden')) return;
      var cb=a.querySelector('input[type="checkbox"]');
      if(cb&&cb.checked) sum+=parseFloat(cb.dataset.price||0)*(a.aQty?a.aQty():1);
    });
    totalEl.textContent=money(sum);
    if(t&&qtyCov) qtyCov.textContent='covers up to '+(parseInt(t.dataset.cov,10)*qty()).toLocaleString()+' sq ft';
  }

  qtyInput.addEventListener('input',function(){ syncActivator(); recalc(); });
  [].slice.call(document.querySelectorAll('.qty > .qty__b')).forEach(function(b){
    b.addEventListener('click',function(){
      qtyInput.value=Math.min(99,Math.max(1,qty()+parseInt(b.dataset.step,10)));
      syncActivator(); recalc();
    });
  });

  tiers.forEach(function(t){
    t.addEventListener('click',function(){
      tiers.forEach(function(x){x.classList.remove('on');});
      t.classList.add('on');
      var r=t.querySelector('input'); if(r) r.checked=true;
      syncActivator(); recalc();
    });
  });

  // ---- add-on rows ----
  addons.forEach(function(a){
    var cb=a.querySelector('input[type="checkbox"]');
    var sel=a.querySelector('.addon__sel');
    var priceEl=a.querySelector('.addon__p');
    var fromLabel=priceEl?priceEl.textContent:'';
    var wrap=a.querySelector('.addon__qty');
    var qf=a.querySelector('.addon__q');
    a.aQty=function(){ return qf?Math.max(1,parseInt(qf.value,10)||1):1; };

    if(wrap){
      wrap.addEventListener('click',function(e){e.stopPropagation();});
      [].slice.call(wrap.querySelectorAll('.qty__b')).forEach(function(b){
        b.addEventListener('click',function(e){
          e.preventDefault(); e.stopPropagation();
          qf.value=Math.min(99,Math.max(1,a.aQty()+parseInt(b.dataset.step,10)));
          recalc();
        });
      });
      qf.addEventListener('click',function(e){e.stopPropagation();});
      qf.addEventListener('input',function(e){e.stopPropagation();recalc();});
    }

    if(cb){
      cb.addEventListener('change',function(){
        if(this.checked && sel && !sel.value){ this.checked=false; sel.focus(); return; }
        a.classList.toggle('on',this.checked);
        if(!this.checked && sel){ sel.value=''; sel.dispatchEvent(new Event('change')); return; }
        if(a===actRow){ syncActivator(); }
        else if(wrap){ if(this.checked){wrap.removeAttribute('hidden');} else {wrap.setAttribute('hidden','');} }
        recalc();
      });
    }

    if(sel){
      sel.addEventListener('click',function(e){e.stopPropagation();});
      sel.addEventListener('change',function(e){
        e.stopPropagation();
        var opt=this.options[this.selectedIndex];
        var chosen=!!this.value;
        cb.dataset.price=chosen?(opt.dataset.price||0):0;
        if(opt.dataset.variant) cb.dataset.variant=opt.dataset.variant;
        cb.checked=chosen;
        a.classList.toggle('on',chosen);
        if(wrap){ if(chosen){wrap.removeAttribute('hidden');} else {wrap.setAttribute('hidden',''); if(qf) qf.value=1;} }
        if(priceEl) priceEl.textContent=chosen?('$'+parseFloat(opt.dataset.price).toFixed(2)):fromLabel;
        recalc();
      });
    }
  });

  // ---- roof type + coating history drive the prep pair ----
  // B = Power Cleaner + Stone Soap   C = Power Cleaner + Nu-Lift
  var PREP={ A:['stone'], B:['power','stone'], C:['power','nulift'], D:['nulift','stone'] };
  var prepRows={power:document.querySelector('.prep--power'),
                nulift:document.querySelector('.prep--nulift'),
                stone:document.querySelector('.prep--stone')};
  var prepHint=document.getElementById('prepHint');
  var silwarn=document.getElementById('silwarn');
  var coatedBtns=[].slice.call(document.querySelectorAll('#coated .qopt'));

  function isCoated(){ var el=document.querySelector('#coated .qopt.on'); return el&&el.dataset.coated==='1'; }

  function clearRow(row){
    if(!row) return;
    var s=row.querySelector('.addon__sel');
    if(s&&s.value){ s.value=''; s.dispatchEvent(new Event('change')); }
  }

  function applyPrep(){
    var opt=subSel.options[subSel.selectedIndex];
    var base=opt?opt.dataset.prep:'';
    var prep = !base ? '' : (isCoated() ? 'C' : base);   // coated or unknown always escalates to C
    var needed=PREP[prep]||[];

    ['power','nulift','stone'].forEach(function(k){
      var row=prepRows[k]; if(!row) return;
      if(needed.indexOf(k)>-1){ row.removeAttribute('hidden'); }
      else { clearRow(row); row.setAttribute('hidden',''); }
    });

    if(prepHint){
      if(!prep) prepHint.textContent='Answer the two questions above and the right cleaners appear here.';
      else if(prep==='C') prepHint.textContent='Previously coated or unknown: Power Cleaner then Nu-Lift (Prep C).';
      else if(prep==='D') prepHint.textContent='Metal needs Nu-Lift to etch and lift oxidation, then Stone Soap (Prep D).';
      else prepHint.textContent='Original membrane: Power Cleaner then Stone Soap (Prep B).';
    }
    if(silwarn) silwarn.classList.toggle('on', isCoated());
    recalc();
  }

  if(subSel) subSel.addEventListener('change',applyPrep);
  coatedBtns.forEach(function(b){
    b.addEventListener('click',function(){
      coatedBtns.forEach(function(x){x.classList.remove('on');});
      b.classList.add('on');
      applyPrep();
    });
  });

  // ---- swatches + SRI ----
  var sws=[].slice.call(document.querySelectorAll('.sw'));
  var swname=document.getElementById('swname');
  var sriVal=document.getElementById('sriVal');
  var sriNote=document.getElementById('sriNote');
  function showSri(el){
    var v=el.dataset.sri;
    if(!v){ sriVal.textContent='SRI —'; sriNote.textContent='Not yet tested for solar reflectance'; return; }
    var n=parseInt(v,10);
    sriVal.textContent='SRI '+n;
    sriNote.textContent = n>=57 ? 'Reflects the most heat' : n>=38 ? 'Mid-range reflectance' : 'Absorbs more heat';
  }
  sws.forEach(function(el){
    el.addEventListener('click',function(){
      sws.forEach(function(x){x.classList.remove('on');});
      el.classList.add('on');
      swname.textContent=el.dataset.name;
      showSri(el);
      syncActivator(); recalc();
    });
  });

  // ---- length -> roof area -> size + quantity ----
  function cheapest(options,area){
    var best=null;
    options.forEach(function(o){
      var cov=parseFloat(o.cov), price=parseFloat(o.price);
      if(!cov||!price) return;
      var packs=Math.ceil(area/cov), cost=packs*price;
      if(!best||cost<best.cost-0.001||(Math.abs(cost-best.cost)<0.001&&cov>best.cov)){
        best={ref:o.ref,label:o.label,cov:cov,price:price,packs:packs,cost:cost};
      }
    });
    return best;
  }
  function fitCleaner(id,area){
    var sel=document.getElementById(id);
    if(!sel) return null;
    var row=sel.closest('.addon');
    if(!row||row.hasAttribute('hidden')) return null;
    var opts=[].slice.call(sel.options).filter(function(o){return o.dataset.cov;})
      .map(function(o){return {ref:o,cov:o.dataset.cov,price:o.dataset.price,label:o.textContent.split(' — ')[0]};});
    var best=cheapest(opts,area);
    if(!best) return null;
    sel.selectedIndex=[].slice.call(sel.options).indexOf(best.ref);
    sel.dispatchEvent(new Event('change'));
    var qf=row.querySelector('.addon__q');
    if(qf) qf.value=best.packs;
    return best;
  }

  var lenInput=document.getElementById('rvlen');
  var areaout=document.getElementById('areaout');

  function runCalc(){
    var len=parseFloat(lenInput.value);
    if(!len||len<=0){ areaout.classList.remove('on'); return; }
    var area=Math.round(len*RV_WIDTH);

    // A quart is a patch size — never recommend a stack of them. Five quarts is
    // marginally cheaper than two gallons and a ridiculous thing to ship someone.
    var tierOpts=tiers
      .filter(function(t){ return !(t.dataset.single==='1' && area>parseFloat(t.dataset.cov)); })
      .map(function(t){return {ref:t,cov:t.dataset.cov,price:t.dataset.price,label:t.dataset.size};});
    var mem=cheapest(tierOpts,area);
    tiers.forEach(function(x){x.classList.remove('on');});
    mem.ref.classList.add('on');
    var r=mem.ref.querySelector('input'); if(r) r.checked=true;
    qtyInput.value=mem.packs;

    var pc=fitCleaner('power',area), nl=fitCleaner('nulift',area), ss=fitCleaner('stonesoap',area);
    function line(n,b){ return b?('<li>'+n+': <strong>'+(b.packs>1?b.packs+' × ':'')+b.label+'</strong></li>'):''; }

    var html='<strong>'+len+' ft</strong> × 8 ft ≈ <strong>'+area.toLocaleString()+' sq ft</strong> of roof, at two coats.<ul>'+
             line('Membrane',mem)+line('Power Cleaner',pc)+line('Nu-Lift Cleaner',nl)+line('Stone Soap',ss)+'</ul>';
    if(!subSel.value) html+='<span style="font-size:13.5px;opacity:.75;font-style:italic">Choose your roof type above and we\'ll add the right cleaners.</span>';
    else html+='<span style="font-size:13.5px;opacity:.75;font-style:italic">Fabric Reinforcement depends on how many vents and joints you have, so we haven\'t guessed at the length.</span>';
    areaout.innerHTML=html;
    areaout.classList.add('on');
    syncActivator(); recalc();
  }
  if(lenInput){
    lenInput.addEventListener('change',runCalc);
    lenInput.addEventListener('keyup',function(e){ if(e.key==='Enter') runCalc(); });
  }
  var cb=document.getElementById('calcBtn'); if(cb) cb.addEventListener('click',runCalc);

  // ---- reviews toggle ----
  var moreBtn=document.getElementById('moreRevs');
  if(moreBtn){
    moreBtn.addEventListener('click',function(){
      var hidden=[].slice.call(document.querySelectorAll('.revmore'));
      var open=!hidden[0].hasAttribute('hidden');
      hidden.forEach(function(r){ if(open){r.setAttribute('hidden','');} else {r.removeAttribute('hidden');} });
      moreBtn.textContent=open?'Show 7 more reviews':'Show fewer reviews';
    });
  }

  // ---- review photo lightbox ----
  var lbox=document.getElementById('lbox'), lboxImg=document.getElementById('lboxImg');
  [].slice.call(document.querySelectorAll('.revpic')).forEach(function(b){
    b.addEventListener('click',function(){
      lboxImg.src=b.dataset.full;
      lboxImg.alt=b.querySelector('img').alt;
      lbox.classList.add('on');
    });
  });
  if(lbox){
    lbox.addEventListener('click',function(){ lbox.classList.remove('on'); lboxImg.src=''; });
    document.addEventListener('keyup',function(e){
      if(e.key==='Escape'&&lbox.classList.contains('on')){ lbox.classList.remove('on'); lboxImg.src=''; }
    });
  }

  // ---- sticky bar ----
  var hero=document.querySelector('.hero'), buy=document.getElementById('product'), sticky=document.getElementById('sticky');
  function onScroll(){
    var past=window.scrollY>hero.offsetHeight;
    var rect=buy.getBoundingClientRect();
    sticky.classList.toggle('on', past && !(rect.top<window.innerHeight && rect.bottom>0));
  }
  window.addEventListener('scroll',onScroll,{passive:true});

  
  // ---- live variant data + add to cart ----
  var variantData=[];
  var blobEl=document.getElementById('lprv-variants');
  if(blobEl){ try{ variantData=JSON.parse(blobEl.textContent)||[]; }catch(e){ variantData=[]; } }
  function findVariant(color,size){
    for(var i=0;i<variantData.length;i++){
      var v=variantData[i];
      if(v.option1===color && v.option2===size) return v;
    }
    return null;
  }
  function currentVariant(){
    var t=currentTier(), c=currentColor();
    return (t&&c)?findVariant(c,t.dataset.size):null;
  }
  function syncPrices(){
    if(!variantData.length) return;
    var c=currentColor();
    tiers.forEach(function(t){
      var v=findVariant(c,t.dataset.size), el=t.querySelector('.tier__p');
      if(v){
        t.dataset.price=(v.price/100).toFixed(2);
        if(el) el.textContent='$'+(v.price/100).toFixed(2);
        t.classList.toggle('soldout', v.available===false);
      }
    });
    recalc();
  }
  var atcBtn=document.getElementById('addToCart');
  var atcNote=document.getElementById('atcNote');
  function note(msg,isErr){
    if(!atcNote) return;
    atcNote.textContent=msg||'';
    if(isErr){atcNote.setAttribute('data-err','1');} else {atcNote.removeAttribute('data-err');}
  }
  if(atcBtn){
    atcBtn.addEventListener('click',function(){
      if(!variantData.length){ note('Product not connected yet - choose the main product in the theme customizer.',true); return; }
      var v=currentVariant();
      if(!v){ note('That color and size combination is not available.',true); return; }
      if(v.available===false){ note('That option is currently out of stock.',true); return; }
      var items=[{id:v.id,quantity:qty()}];
      addons.forEach(function(a){
        if(a.hasAttribute('hidden')) return;
        var cb=a.querySelector('input[type="checkbox"]');
        if(!cb||!cb.checked||!cb.dataset.variant) return;
        items.push({id:Number(cb.dataset.variant),quantity:(a.aQty?a.aQty():1)});
      });
      atcBtn.disabled=true; note('Adding to cart...');
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({items:items})})
      .then(function(r){ return r.json().then(function(d){ if(!r.ok) throw new Error(d.description||d.message||'Could not add to cart.'); return d; }); })
      .then(function(){ window.location='/cart'; })
      .catch(function(err){ atcBtn.disabled=false; note(err.message,true); });
    });
  }
  sws.forEach(function(el){ el.addEventListener('click',syncPrices); });
  syncPrices();
  applyPrep(); syncActivator(); onScroll(); recalc();
})();
